import { RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { PersonalizeActions } from './personalize.actions';

export interface PersonalizeState {
    error: any;
    personalizingFinished: boolean;
    personalizingLoading: boolean;
}

export const PERSONALIZE_INITIAL_STATE: PersonalizeState = {
    error: null,
    personalizingFinished: false,
    personalizingLoading: false
};

export const PERSONALIZE_STATE_KEY = 'personalize';

export function personalizeReducer(
    lastState: PersonalizeState = PERSONALIZE_INITIAL_STATE,
    action: RidangoReduxAction
): PersonalizeState {
    switch (action.type) {
        case PersonalizeActions.RESET_PERSONALIZED_STATE:
            return PERSONALIZE_INITIAL_STATE;
        case PersonalizeActions.SAVE_PERSONALIZED_CARD:
            return tassign(lastState, {
                personalizingFinished: false
            });
        case PersonalizeActions.SAVE_PERSONALIZED_CARD_SUCCESS:
            return tassign(lastState, {
                ...action.payload,
                personalizingFinished: true,
                error: null
            });
        case PersonalizeActions.SAVE_PERSONALIZED_CARD_FAILED:
            return tassign(lastState, {
                error: action.payload,
                personalizingFinished: true
            });
        case PersonalizeActions.SAVE_PERSONALIZED_CARD_NO_ISSUE:
            return tassign(lastState, {
                personalizingFinished: false
            });
        case PersonalizeActions.SAVE_PERSONALIZED_CARD_NO_ISSUE_SUCCESS:
            return tassign(lastState, {
                ...action.payload,
                personalizingFinished: true,
                error: null
            });
        case PersonalizeActions.SAVE_PERSONALIZED_CARD_NO_ISSUE_FAILED:
            return tassign(lastState, {
                error: action.payload,
                personalizingFinished: true
            });
        case PersonalizeActions.SET_PERSONALIZED_LOADING:
            return tassign(lastState, {
                personalizingLoading: action.payload
            });
    }

    return lastState;
}

export interface PersonalizePartialStoreState {
    [PERSONALIZE_STATE_KEY]: PersonalizeState;
}
